<template>
    <el-container id="discountMain" style="height: 680px;border: 1px solid #eee">
        <el-header>
            <el-row :gutter="24">
                <el-col :offser="2" :span="4">
                    <el-select v-model="searchShopid" @change="refreshData" :placeholder="$t('other.a359')">
                        <el-option
                                v-for="(item,index) in userShopidsOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="searchKeyword" :placeholder="$t('other.a1573')">
                        <el-option
                                v-for="item in keyWordOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="searchValue" :placeholder="$t('other.a1574')">
                    </el-input>
                </el-col>
                <el-col :span="2">
                    <el-button @click="refreshData">{{$t('other.a916')}}</el-button>
                </el-col>
                <el-col :offset="4" :span="3">
                    <el-button type="primary" @click="getMonitorRule">{{$t('other.a1575')}}</el-button>
                </el-col>
            </el-row>
        </el-header>
        <el-main>
            <el-tabs v-model="activeTab" @tab-click="handleClick">
                <el-tab-pane :label="$t('other.a1576')" name="first">
                    <el-table
                            ref="accountItemListTable"
                            :data="getCurrentPage"
                            style="width: 100%"
                            row-key="rowKey"
                            border
                            lazy
                            :load="load"
                            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                        <el-table-column
                                prop="name"
                                :label="$t('other.a817')"
                                algin="center">
                        </el-table-column>
                        <el-table-column
                                prop="country"
                                :label="$t('other.a1577')">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                :label="$t('other.a1346')">
                        </el-table-column>
                        <el-table-column
                                prop="price"
                                :label="$t('other.a1578')">
                        </el-table-column>
                        <el-table-column
                                    fixed="right"
                                    :label="$t('other.a33')"
                                    width="100">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.showOperation">
                                        <el-row>
                                            <el-col :spam="24">
                                                <el-button @click="sendUserItem2bind(scope.row)" type="text" size="small">{{$t('other.a1579')}}</el-button>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </template>
                            </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('other.a1580')" name="second">
                    <el-table
                            ref="accountItemListTable"
                            :data="getCurrentPage"
                            style="width: 100%"
                            row-key="rowKey1"
                            border
                            lazy
                            :tree-props="{children: 'variation', hasChildren: 'hasChildren'}">
                        <el-table-column
                                prop="name"
                                :label="$t('other.a817')"
                                algin="center">
                        </el-table-column>
                        <el-table-column
                                prop="discountId"
                                :label="$t('other.a1581')">
                        </el-table-column>
                        <el-table-column
                                prop="lastPromotionPrice"
                                :label="$t('other.a1582')">
                        </el-table-column>
                        <el-table-column
                                prop="endTime"
                                :label="$t('other.a1583')">
                        </el-table-column>
                        <el-table-column
                                prop="comment"
                                :label="$t('other.a1156')">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                :label="$t('other.a33')"
                                width="100">
                            <template slot-scope="scope">
                                <div v-if="scope.row.hasVariation === false">
                                    <el-row>
                                        <el-col :spam="24">
                                            <el-button type="text" @click="sendItem2relieve(scope.row)" size="small">{{$t('other.a1584')}}</el-button>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :spam="24">
                                            <el-button type="text" @click="getMonitorPriceImg" size="small">{{$t('other.a1585')}}</el-button>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :spam="24">
                                            <el-button type="text" @click="setUpdateMonitorRuleInfo(scope.row)" size="small">{{$t('other.a1586')}}</el-button>
                                        </el-col>
                                    </el-row>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <!--修改商品弹出框 -->
            <el-dialog
                    :title="$t('other.a1587')"
                    :visible.sync="updateDiscountItem"
                    width="30%">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item :label="$t('other.a1589')">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1590')">
                        <el-select v-model="form.region" :placeholder="$t('other.a1591')">
                            <el-option :label="$t('other.a1592')" value="shanghai"></el-option>
                            <el-option :label="$t('other.a1593')" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1594')">
                        <el-col :span="22">
                            <div class="block">
                                <span class="demonstration">{{$t('other.a1588')}}</span>
                                <el-date-picker
                                        v-model="form.date1"
                                        type="daterange"
                                        :range-separator="$t('other.a47')"
                                        :start-placeholder="$t('other.a45')"
                                        :end-placeholder="$t('other.a46')">
                                </el-date-picker>
                            </div>
                        </el-col>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1595')">
                        <el-switch v-model="form.delivery"></el-switch>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1596')">
                        <el-checkbox-group v-model="form.type">
                            <el-checkbox :label="$t('other.a1597')" name="type"></el-checkbox>
                            <el-checkbox :label="$t('other.a1598')" name="type"></el-checkbox>
                            <el-checkbox :label="$t('other.a1599')" name="type"></el-checkbox>
                            <el-checkbox :label="$t('other.a1600')" name="type"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1601')">
                        <el-radio-group v-model="form.resource">
                            <el-radio :label="$t('other.a1602')"></el-radio>
                            <el-radio :label="$t('other.a1603')"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1604')">
                        <el-input type="textarea" v-model="form.desc"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
    <el-button @click="updateDiscountItem = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="updateDiscountItem = false">{{$t('other.a279')}}</el-button>
  </span>
            </el-dialog>
            <!--添加商品弹出框 -->
            <el-dialog
                    :title="$t('other.a1605')"
                    :visible.sync="addDiscountItem"
                    width="75%"
                    top="8vh">
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item :label="$t('other.a1589')">
                        <el-input :placeholder="$t('other.a1589')" v-model="addAutoDiscountItemsInfo.discountName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1606')">
                        <div class="block">
                            <el-date-picker
                                    v-model="addAutoDiscountItemsInfo.endTime"
                                    align="right"
                                    type="date"
                                    :placeholder="$t('other.a866')"
                                    :picker-options="pickerOptions2">
                            </el-date-picker>
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1607')">
                        <el-checkbox-group v-model="form.type" style="overflow-x: hidden;height: 200px">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                                {{$t('other.a378')}}
                            </el-checkbox>
                            <!--                    <div style="margin: 15px 0;"></div>-->
                            <el-checkbox-group v-model="checkedItems" @change="handleCheckedCitiesChange">
                                <div v-for="(item,index) in accountItemList">
                                    <el-row class="tac">
                                        <el-col :span="24">
                                            <el-menu
                                                    default-active="2"
                                                    class="el-menu-vertical-demo"
                                                    @open="handleOpen"
                                                    @close="handleClose">
                                                <el-submenu index="1">
                                                    <template slot="title">
                                                        <el-col :span="4"
                                                                style="width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-break:keep-all;display:block;">
                                                            <el-checkbox v-bind:value="item.itemId"
                                                                         :label="item.itemId"
                                                                         :id='"itemId"+item.itemId'
                                                                         v-bind:title="item.name"
                                                                         :key="item.itemId">
                                                                {{item.name}}
                                                            </el-checkbox>
                                                        </el-col>
                                                        <el-col :offset="1" :span="4">
                                                            <el-input type="number"
                                                                      :disabled="true"
                                                                      v-model="accountItemList[index].price"
                                                                      maxlength="15"
                                                                      :placeholder="$t('other.a1608')"></el-input>
                                                        </el-col>
                                                        <el-col :offset="1" :span="4">
                                                            <el-input type="number"
                                                                      v-model="accountItemList[index].promotionPrice"
                                                                      :id='"itemPrice"+item.itemId'
                                                                      maxlength="15"
                                                                      :placeholder="$t('other.a1609')"></el-input>
                                                        </el-col>
                                                        <el-col :offset="1" :span="4">
                                                            <el-input type="number"
                                                                      :id='"itemLimit"+item.itemId'
                                                                      v-model="accountItemList[index].purchaseLimit"
                                                                      maxlength="15"
                                                                      :placeholder="$t('other.a1610')"></el-input>
                                                        </el-col>
                                                    </template>
                                                    <div v-if="item.children.length !== 0">
                                                        <el-menu-item-group>
                                                            <template slot="title">variations</template>
                                                            <div v-for="(variation,size) in item.children">
                                                                <el-menu-item index="1-1" class="variationList">
                                                                    <el-col :span="4"
                                                                            style="width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-break:keep-all;display:block;">
                                                                        <el-checkbox v-bind:value="item.itemId"
                                                                                     :id='"variationId"+variation.variationId'
                                                                                     :label="variation.variationId"
                                                                                     v-bind:title='item.name +"  "+ variation.name'
                                                                                     :key="item.itemId">{{item.name}} +
                                                                            {{variation.name}}
                                                                        </el-checkbox>
                                                                    </el-col>
                                                                    <el-col :offset="1" :span="4">
                                                                        <el-input type="number" :disabled="true"
                                                                                  v-model="variation.price"
                                                                                  maxlength="15"
                                                                                  :placeholder="$t('other.a1608')"></el-input>
                                                                    </el-col>
                                                                    <el-col :offset="1" :span="4">
                                                                        <el-input type="number"
                                                                                  :id='"variationPrice" + variation.variationId'
                                                                                  v-model="accountItemList[index].children[size].promotionPrice"
                                                                                  maxlength="15"
                                                                                  :placeholder="$t('other.a1609')"></el-input>
                                                                    </el-col>
                                                                    <el-col :offset="1" :span="4">
                                                                        <el-input type="number"
                                                                                  :id='"variationLimit" + variation.variationId'
                                                                                  v-model="accountItemList[index].children[size].purchaseLimit"
                                                                                  maxlength="15"
                                                                                  :placeholder="$t('other.a1610')"></el-input>
                                                                    </el-col>
                                                                </el-menu-item>
                                                            </div>
                                                        </el-menu-item-group>
                                                    </div>
                                                </el-submenu>
                                            </el-menu>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-checkbox-group>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
    <el-button @click="addDiscountItem = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="AutoContinue">{{$t('other.a279')}}</el-button>
  </span>
            </el-dialog>
            <!--商品详细信息弹出框 -->
            <el-dialog
                    :title="$t('other.a1605')"
                    :visible.sync="itemDetail"
                    width="45%">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item :label="$t('other.a179')">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1609')">
                        <el-input v-model="form.region" type="number"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1604')">
                        <el-input type="textarea"  v-model="form.desc"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
    <el-button @click="itemDetail = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="itemDetail = false">{{$t('other.a279')}}</el-button>
  </span>
            </el-dialog>
            <!--监控对手商品信息弹出框-->
            <el-dialog
                    :title="$t('other.a1611')"
                    :visible.sync="addMonitorItem"
                    width="60%"
                    @close="clearBindData">
                <el-row>
                    <el-col :span="2">
                        <label for="monitorItemUrlContent">{{$t('other.a1240')}}</label>
                    </el-col>
                    <el-col :span="16">
                        <el-input id="monitorItemUrlContent" v-model="monitorItemUrl"></el-input>
                    </el-col>
                    <el-col :offset="1" :span="3">
                        <el-button type="primary" @click="addMonitorItemUrl">{{$t('other.a1612')}}</el-button>
                    </el-col>
                </el-row>
                <br>
                <el-row>
                    <el-col :span="2">
                        <label>{{$t('other.a1613')}}</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input v-model.number="bottomPrice" type='number' maxlength='9'></el-input>
                    </el-col>
                </el-row>
                <br>
                <el-row>
                    <el-col :span="2">
                        <label>{{$t('other.a1614')}}</label>
                    </el-col>
                    <el-col :span="6" >
                        <el-select  v-model="cutType" :placeholder="$t('other.a1622')">
                            <el-option :label="$t('other.a1623')"  value="0"></el-option>
                            <el-option :label="$t('other.a1624')" value="1"></el-option>
                            <el-option :label="$t('other.a1625')" value="2"></el-option>
                            <el-option :label="$t('other.a1626')" value="3"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <br>
                <div v-if="cutType === '2'">
                    <el-row>
                        <el-col :span="2">
                            <label>{{$t('other.a1615')}}</label>
                        </el-col>
                        <el-col :span="6">
                            <el-input v-model.number="cutPrice"  type='number' maxlength='9'></el-input>
                        </el-col>
                    </el-row>
                </div>
                <div v-if="cutType === '3'">
                    <el-row>
                        <el-col :span="2">
                            <label>{{$t('other.a1615')}}</label>
                        </el-col>
                        <el-col :span="6">
                            <el-input v-model.number="cutPrice"  type='number' maxlength='9'></el-input>
                        </el-col>
                    </el-row>
                </div>
                <br>
                <el-row>
                    <el-col :span="2">
                        <label for="monitorItemComment">{{$t('other.a1156')}}：</label>
                    </el-col>
                    <el-col :span="16">
                        <el-input type="textarea" :row="3" :placeholder="$t('other.a1627')" id="monitorItemComment" v-model="monitorItemComment"></el-input>
                    </el-col>
                </el-row>
                <br>
                <el-row>
                    <el-col :span="10">
                        <div class="block">
                            <span class="demonstration">{{$t('other.a46')}}：</span>
                            <el-date-picker
                                    v-model="endTime"
                                    type="date"
                                    :placeholder="$t('other.a866')">
                            </el-date-picker>
                        </div>
                    </el-col>
                </el-row>
                <br>
                <el-table
                        ref="selected2MonitorItems"
                        :data="monitorModels"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionAccountModel2MonitorSelected">
                    <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                    fixed="left"
                    prop="img"
                    :label="$t('other.a1628')">
                        <template slot-scope="scope">
                            <el-image :src="scope.row.img"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="modelId"
                            :label="$t('other.a1370')"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="modelName"
                            :label="$t('other.a1629')"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="modelPromotionPrice"
                            :label="$t('other.a1578')">
                    </el-table-column>
                    <el-table-column
                            prop="platform"
                            :label="$t('other.a481')">
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
    <el-button @click="addMonitorItem = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="bindAccountItem2MonitorItem">{{$t('other.a1616')}}</el-button>
  </span>
            </el-dialog>
            <!-- 监控规则弹出窗 -->
            <el-dialog
                    :title="$t('other.a1630')"
                    :visible.sync="displayRules"
                    width="30%">
                <span>{{$t('other.a1617')}}：{{rules[0]}}</span>
                <br>
                <span>{{$t('other.a1618')}}：{{rules[1]}}</span>
                <br>
                <br>
                <span style="color:red;font-weight: bold">Tips:{{$t('other.a1619')}}</span>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="displayRules = false">{{$t('other.a279')}}</el-button>
                 </span>
            </el-dialog>
            <!-- 解除监控弹出窗 -->
            <el-dialog
                    :title="$t('other.a142')"
                    :visible.sync="relieveItemBindDig"
                    width="30%"
                    :before-close="handleClose">
                <span style="color:red;font-weight: bolder">{{$t('other.a1620')}}</span>
                <span slot="footer" class="dialog-footer">
                <el-button @click="relieveItemBindDig = false">{{$t('other.a106')}}</el-button>
                <el-button type="primary" @click="relieveItemBind">{{$t('other.a279')}}</el-button>
                </span>
            </el-dialog>
            <!-- 价格流图弹出窗 -->
            <el-dialog
                :title="$t('other.a1631')"
                :visible.sync="priceFlowDig"
                width="30%"
                :before-close="handleClose">
                <span>{{$t('other.a1621')}}</span>
            <div id="priceFlow"></div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="priceFlowDig = false">{{$t('other.a279')}}</el-button>
                </span>
        </el-dialog>
            <!-- 修改监控规则弹出窗 -->
            <el-dialog
                    :title="$t('other.a1586')"
                    :visible.sync="updateMonitorRuleDig"
                    width="60%"
                    @close="clearBindData">
                <el-row>
                </el-row>
                <br>
                <el-row>
                    <el-col :span="3">
                        <label>{{$t('other.a1613')}}</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input v-model.number="updateMonitorInfo.bottomPrice" type='number' maxlength='9'></el-input>
                    </el-col>
                </el-row>
                <br>
                <el-row>
                    <el-col :span="3">
                        <label>{{$t('other.a1614')}}</label>
                    </el-col>
                    <el-col  :span="6" >
                        <el-select  v-model="updateMonitorInfo.cutType" :placeholder="$t('other.a1622')">
                            <el-option :label="$t('other.a1623')"  value="0"></el-option>
                            <el-option :label="$t('other.a1624')" value="1"></el-option>
                            <el-option :label="$t('other.a1625')" value="2"></el-option>
                            <el-option :label="$t('other.a1626')" value="3"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <br>
                <div v-if="updateMonitorInfo.cutType === '2'">
                    <el-row>
                        <el-col :span="3">
                            <label>{{$t('other.a1615')}}</label>
                        </el-col>
                        <el-col :span="6">
                            <el-input v-model.number="updateMonitorInfo.cutPrice"  type='number' maxlength='9'></el-input>
                        </el-col>
                    </el-row>
                </div>
                <div v-if="updateMonitorInfo.cutType === '3'">
                    <el-row>
                        <el-col :span="3">
                            <label>{{$t('other.a1615')}}</label>
                        </el-col>
                        <el-col :span="6">
                            <el-input v-model.number="updateMonitorInfo.cutPrice"  type='number' maxlength='9'></el-input>
                        </el-col>
                    </el-row>
                </div>
                <br>
                <br>
                <el-table
                        :data="displayMonitorDataInfo"
                        tooltip-effect="dark"
                        style="width: 100%">
                    <el-table-column
                            fixed="left"
                            :label="$t('other.a1628')">
                        <template slot-scope="scope">
                            <el-image :src="scope.row.modelImgUrl"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="modelId"
                            :label="$t('other.a1370')"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="lastPromotionPrice"
                            :label="$t('other.a1632')"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="comment"
                            :label="$t('other.a1156')">
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
    <el-button @click="updateMonitorRuleDig = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="updateMonitorRule">{{$t('other.a1586')}}</el-button>
  </span>
            </el-dialog>
        </el-main>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[20, 50, 100,]"
                :page-size="20"
                layout="total, sizes, prev, pager, next, jumper"
                :total="activeTab ==='first'? accountTotalItemSize:accountMonitorItemCount">
        </el-pagination>
    </el-container>
</template>
<script>
    import operation from "../../api/moudles/operation"
    import 'element-ui';
    import api from "../../api/api";
    import echarts from "echarts"
    export default {
        name: "discountShoppe",
        components:{
        },
        data() {
            return {
                activeTab:'first',
                keyWordOptions: [
                    {value:"name",label:this.$t('other.a1633')},
                    {value:"sku",label:this.$t('other.a1634')}
                ],
                statusOptions:[
                    {value:"ALL",label:this.$t('other.a1635')},
                    {value:"MODEL_NORMAL",label:this.$t('other.a1636')},
                    {value:"BANNED",label:this.$t('other.a1637')},
                    {value:"DELETED",label:this.$t('other.a1638')}
                ],
                userShopidsOptions:[

                    ],
                itemLimit:20,
                itemOffset:0,
                searchShopid: null,
                searchStatus:"",
                ifBoundless:0,
                endTime:'',
                testData:'',
                addAutoDiscountItemsInfo:{
                    autoDiscountItems:[],
                    discountName:'',
                    endTime:'',
                    shopid:235415214
                },
                shopItems:[],
                price:'',
                checkAll: false,
                checkedItems: [],
                isIndeterminate: true,
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                },
                itemDetail:false,
                /**
                 * 监控商品的URl
                 */
                monitorItemUrl:'',
                /**
                 * 修改折扣商品信息弹出框控制
                 **/
                updateDiscountItem: false,
                /**
                 * 增加折扣商品信息弹出框控制
                 **/
                addDiscountItem:false,
                /**
                 * 添加监控商品url信息弹出框控制
                 */
                addMonitorItem: false,
                bottomPrice:0,
                cutPrice:0.9,
                cutType:'0',
                monitorItemComment:"",
                /**
                 * 折扣商品列表
                 */
                discountList: [],
                currentItemListLen:1,
                /**
                 * 根据限制条件获取指定店铺的item信息
                 **/
                accountItemList:[],
                /**
                 * 根据不同店铺获取的店铺商品监控信息
                 **/
                accountMonitorItemList:[],
                /**
                 * 暂存添加折扣商品信息列表
                 **/
                tempAddDiscountItemInfo:[
                    {
                        itemId:1,
                        itemPromotionPrice:1,
                        itemPurchaseLimit:1,
                        variationInfo:[
                            {
                                variationId:1,
                                variationPromotionPrice:1,
                                variationPurchaseLimit:1
                            }
                        ]
                    }
                ],
                /**
                 *查询商品选择的时间，包括上下限
                 **/
                updateTime: '',
                /**
                 *自动添加活动模块的日期选择器限制
                 * */
                pickerOptions2:{
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    }
                },
                /**
                 * 用户选择要绑定的Item
                 */
                ready2bindItem: {},
                /**
                 * 通过url获取的商品列表
                 */
                monitorModels:[],
                /**
                 * 用户列表选择的modal
                 */
                model2MonitorSelected:[],
                currentPage: 1,
                pageInfo:{
                    offset:0,
                    pageSize:20
                },
                /**
                 *规则弹窗控制
                 */
                displayRules:false,
                /**
                 * 规则数组
                 */
                rules:[],
                //控制接触绑定弹窗
                relieveItemBindDig:false,
                //用户解除绑定信息的Item
                ready2relieveItem:{},
                //搜索关键词
                searchKeyword:"",
                //搜索值
                searchValue:'',
                //用户产品总条数
                accountTotalItemSize:20,
                //控制价格流图的弹窗
                priceFlowDig:false,
                updateMonitorInfo:{},
                updateMonitorRuleDig:false,
                displayMonitorDataInfo:{},
            };
        },
        created() {
            let shopidInfo = JSON.parse(localStorage.getItem("shopIdInfo"))
            if(shopidInfo !== null){
                shopidInfo.forEach(item=>{
                    this.userShopidsOptions.push({
                        value:item.shopId,
                        label:item.shopName
                    })
                })
            }
            // this.getAccountItemsList()
            // this.getAccountMonitorItemList()
        },
        methods: {
            /**
             *获取用户商品列表
             **/
            getAccountItemsList() {
                const params = {
                    keyword: this.searchKeyword,
                    limit: this.pageInfo.pageSize,
                    page: this.pageInfo.offset,
                    shopid:this.searchShopid,
                    userAccount:JSON.parse(localStorage.getItem("userInfo")).userId,
                    token: "shopee-extension-erp",
                    value: this.searchValue
                }
                console.log("shopid",this.searchShopid)
                operation
                    .getAccountItemsList(params)
                    .then(res => {
                        this.accountItemList = res.data.data.items.map((item) => {
                            return {
                                showOperation: item.hasVariation===0 ? true : false,
                                rowKey: item.itemId,
                                itemId: item.itemId,
                                itemName: item.name,
                                country: item.currency,
                                price: item.price,
                                status: item.status,
                                discountId: item.discountId,
                                variationName:null,
                                variationId:null,
                                name:item.name,
                                children: item.variations.map((variation) => {
                                    return {
                                        showOperation:true,
                                        itemName:item.name,
                                        rowKey: variation.variationId,
                                        itemId: item.itemId,
                                        variationName: variation.name,
                                        price: variation.price,
                                        country: item.currency,
                                        status: variation.status,
                                        variationId: variation.variationId,
                                        discountId: item.discountId,
                                        name:variation.name
                                    }
                                })
                            }
                        });
                        this.accountTotalItemSize = res.data.total
                        console.log(this.accountTotalItemSize)
                        console.log(this.accountItemList)
                    })
            },
            getAccountMonitorItemList(){
                const params = {
                    shopid:this.searchShopid,
                    token: "shopee-extension-erp",
                    userAccount:JSON.parse(localStorage.getItem("userInfo")).userId,
                }
                operation
                .getShopMonitorInfo(params)
                .then(resp=>{
                    let monitorItemListJson =resp.data.items;
                    var accountMonitorItems = []
                    let monitorItemList = []
                    for (let index in monitorItemListJson){
                        let itemArray = monitorItemListJson[index]
                        itemArray.forEach(item =>{
                            let rnd = ""
                            rnd += Math.floor(Math.random()*10000);
                            // let monitorItemList = []
                            monitorItemList.push({
                                rowKey1:rnd,
                                itemId:item.itemId,
                                name: item.itemName,
                                discountId: item.discountId,
                                lastPromotionPrice: item.lastPromotionPrice,
                                priceStrategyId: item.priceStrategyId,
                                endTime: item.endTime,
                                modelId: item.modelId,
                                comment: item.comment,
                                modelImg: item.variation === null ? item.modelImgUrl : null,
                                hasVariation: item.variation === null? false:true,
                                variation: item.variation === null ? null : [{
                                        rowKey1:"variation"+rnd,
                                        itemId:item.itemId,
                                        variationId:item.variation.variationId,
                                        name: item.variation.variationName,
                                        discountId: item.variation.discountId,
                                        modelId: item.variation.modelId,
                                        comment:item.variation.comment,
                                        lastPromotionPrice: item.variation.lastPromotionPrice,
                                        hasVariation:false,
                                        modelImg: item.variation.modelImgUrl,
                                    }]
                                })
                        })
                    }
                    this.accountMonitorItemList = monitorItemList
                    console.log(this.accountMonitorItemList)
                })
            },
            /**
             * 关闭绑定页面窗口清空需要绑定的model数据
             */
            clearBindData(){
                this.monitorModels = [];
                this.addMonitorItem = false;
                this.model2MonitorSelected = [];
                this.monitorItemUrl = "";
                this.endTime = "";
                this.cutType = 0;
                this.cutPrice = 0;
                this.bottomPrice = 0
            },
            /**
             *获取活动商品列表信息
             **/
            getDiscountList() {
                let dateNumber = this.dateMinus(this.selectedTime[0], this.selectedTime[1])
                if (new Date(this.selectedTime[0]).getTime() > new Date(this.selectedTime[1])) {
                    alert(this.$t('other.a1639'))
                }
                if (new Date(this.selectedTime[0]).getTime() <= new Date(this.selectedTime[1])) {
                    if (dateNumber > 15) {
                        alert(this.$t('other.a1640'))
                    }
                    if (dateNumber <= 15) {
                        let accessToken = JSON.parse(localStorage.getItem("emailInfo")).accessToken
                        const params = {
                            shopid: this.searchShopid,
                            pagination_entries_per_page: this.searchNumber,
                            pagination_offset: 0,
                            discount_status: "ALL",
                            update_time_from: new Date(this.selectedTime[0]).getTime() / 1000,
                            update_time_to: new Date(this.selectedTime[1]).getTime() / 1000,
                            accessToken: accessToken
                        }
                        operation.getDiscountList(params)
                            .then(res => {
                                this.discountList = res.data.discount
                                this.discountList.forEach((item, index) => {
                                    this.discountList[index].start_time = this.formatTimestamp2Date(item.start_time, "Y");
                                    this.discountList[index].end_time = this.formatTimestamp2Date(item.end_time, "Y")
                                    this.discountList[index].status = this.getChStatus(item.status)
                                })
                            })
                    }
                }

            },
            /**
             * 判单两个日期相差多少天
             * @param dateStart
             * @param dateEnd
             * @returns {number}
             */
            dateMinus(dateStart, dateEnd) {
                let sdate = new Date(dateStart);
                let now = new Date(dateEnd);
                let days = now.getTime() - sdate.getTime();
                let day = Math.floor(days / (1000 * 60 * 60 * 24));
                return day;
            },
            handleClose(done) {
                this.$confirm(this.$t('other.a1641'))
                    .then(() => {
                        done();
                    })
                    .catch(() => {
                    });
            },
            // 通过时间戳获取正常的时间显示
            formatTimestamp2Date(data, type) {
                var _data = data;
                //如果是13位正常，如果是10位则需要转化为毫秒
                if (String(data).length == 13) {
                    _data = data
                } else {
                    _data = data * 1000
                }
                const time = new Date(_data);
                const Y = time.getFullYear();
                const Mon = time.getMonth() + 1;
                const Day = time.getDate();
                const H = time.getHours();
                const Min = time.getMinutes();
                const S = time.getSeconds();
                //自定义选择想要返回的类型
                if (type == "Y") {
                    return `${Y}-${Mon}-${Day}`
                } else if (type == "H") {
                    return `${H}:${Min}:${S}`
                } else {
                    return `${H}:${Min}:${S} ${Y}-${Mon}-${Day}`
                }
            },
            getChStatus(status) {
                switch (status) {
                    case "expired":
                        return this.$t('other.a1642')
                    case "ongoing":
                        return this.$t('other.a1643')
                }
            },
            onSubmit() {
                console.log('submit!');
            },
            handleCheckAllChange(val) {
                this.checkedItems = val ? this.accountItemList : [];
                this.isIndeterminate = false;
            },
            /**
             * 全选控制按钮
             * @param value
             */
            handleCheckedCitiesChange(value) {
                console.log(value === this.checkedItems)
                console.log(this.checkedItems)
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.accountItemList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.accountItemList.length;
            },
            /**
             * 添加活动自动续期商品
             **/
            addAutoDiscount() {
                this.addDiscountItem = false
                const params = {
                    autoDiscountItems: this.addAutoDiscountItemsInfo.autoDiscountItems,
                    discountName: this.addAutoDiscountItemsInfo.discountName,
                    endTime: new Date(this.addAutoDiscountItemsInfo.endTime).getTime() / 1000,
                    shopid: this.addAutoDiscountItemsInfo.shopid
                }
                operation
                    .addAutoDiscount(params)
                    .then(res => {
                        //清空addAutoDiscountItemsInfo内容
                        this.addAutoDiscountItemsInfo = {
                            autoDiscountItems: [],
                            discountName: '',
                            endTime: '',
                            shopid: this.searchShopid
                        }

                    })
            },
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            /**
             * 添加活动自动续期商品
             */
            AutoContinue() {
                let autoDiscountItemList = []
                //分别取出已被选择的商品 variation 跟 item列表
                //遍历已选列表，如果列表元素长度为10,则是itemId
                let selectedItemIdList = this.checkedItems.map((item) => {
                    if (item > 999999999 && item < 9999999999) {
                        return item
                    }
                })
                //遍历已选列表，如果元素长度为11，则是variationId
                let selectedVariationIdList = this.checkedItems.map((item) => {
                    if (item > 9999999999 && item < 99999999999) {
                        return item
                    }
                })
                //遍历客户商品列表，获取表单内容
                this.accountItemList.forEach((item, index) => {
                    let itemId = item.itemId
                    if (selectedItemIdList.includes(itemId)) {
                        let autoDiscountItem = {
                            itemId: itemId,
                            variationId: null,
                            variationPromotionPrice: null,
                            itemPromotionPrice: item.promotionPrice,
                            purchaseLimit: item.purchaseLimit
                        }
                        autoDiscountItemList.push(autoDiscountItem)
                    }
                    let variations = item.variations
                    variations.forEach((variation, size) => {
                        if (selectedVariationIdList.includes(variation.variationId)) {
                            let autoDiscountItem = {
                                itemId: itemId,
                                variationId: variation.variationId,
                                variationPromotionPrice: variation.promotionPrice,
                                itemPromotionPrice: null,
                                purchaseLimit: variation.purchaseLimit
                            }
                            autoDiscountItemList.push(autoDiscountItem)
                        }
                    })
                })
                //封装数据发送请求
                const params = {
                    autoDiscountItems: autoDiscountItemList,
                    discountName: this.addAutoDiscountItemsInfo.discountName,
                    endTime: new Date(this.addAutoDiscountItemsInfo.endTime).getTime() / 1000,
                    shopid: this.addAutoDiscountItemsInfo.shopid,
                    token: "shopee-extension-erp",
                    userAccount: JSON.parse(localStorage.getItem("userInfo")).userId
                }
                operation.addAutoDiscount(params)
                    .then(res => {
                        this.addDiscountItem = false
                    })

            },
            /**
             * 获取url对应商品信息
             */
            addMonitorItemUrl() {
                /**
                 * 获取URl对应页面商品的信息
                 */
                let ItemUrl = this.monitorItemUrl
                let itemInfo
                operation
                    .monitoringGoods(ItemUrl)
                    .then(resp => {
                        itemInfo = resp.data
                        this.monitorModels = resp.data
                    })
                return itemInfo
            },
            /**
             * 绑定页面model与用户产品
             */
            bindAccountItem2MonitorItem() {
                this.addMonitorItem = false
                const accountItem = this.ready2bindItem
                this.ready2bindItem ={}
                const monitorItems = this.model2MonitorSelected
                // console.log("要绑定的model",monitorItems)
                let bindParams = []
                monitorItems.map((item,index) => {
                    let userInfo = JSON.parse(localStorage.getItem("userInfo"))
                    bindParams.push({
                        comment: this.monitorItemComment,
                        bottomPrice: this.bottomPrice,
                        cutPrice:this.cutPrice,
                        cutType:parseInt(this.cutType),
                        itemId: accountItem.itemId,
                        itemName: accountItem.name,
                        variationId: accountItem.variationId,
                        variationName: accountItem.variationName,
                        lastPromotionPrice: accountItem.price,
                        discountId: accountItem.discountId,
                        endTime: this.endTime,
                        modelId: item.modelId,
                        modelImgUrl: item.img,
                        modelName: item.modelName,
                        modelPromotionPrice: item.modelPromotionPrice,
                        modelUrl: this.monitorItemUrl,
                        priceStrategyId:1,
                        shopid: this.searchShopid,
                        token: "shopee-extension-erp",
                        userAccount: JSON.parse(localStorage.getItem("userInfo")).userId
                    })
                })
                operation
                .bindAccountItem2model(bindParams)
                .then(resp =>{
                    this.clearBindData();
                    if(resp.code === 2101){
                        alert(resp.msg);
                    }
                })
                // console.log(bindParams)
            },
            sendUserItem2bind(item){
                this.addMonitorItem = true
                this.ready2bindItem = item
            },
            handleSelectionAccountModel2MonitorSelected(val){
                console.log(val)
                this.model2MonitorSelected = val;
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageInfo.pageSize = parseInt(`${val}`)
                if (this.activeTab === 'first'){
                    this.getAccountItemsList()
                }
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.pageInfo.offset = parseInt(`${val}`)
                if (this.activeTab === 'first'){
                    this.getAccountItemsList()
                }
            },
            /**
             * 加载用户item列表数据的方法（加载子树）
             * @param tree
             * @param treeNode
             * @param resolve
             */
            load(tree,treeNode,resolve){
                // console.log(treeNode)
                setTimeout(()=>{
                    resolve(treeNode.children)
                })
            },
            handleClick(tab, event) {
                this.refreshData();
                // console.log(tab, event);
            },
            getMonitorRule(){
                operation
                .getMonitorRules()
                .then(resp=>{
                    this.rules = resp.data.promotionType;
                    this.displayRules = true;
                })
            },
            //设置要解除的Item
            sendItem2relieve(item){
                this.ready2relieveItem = item;
                this.relieveItemBindDig = true;
            },
            //解除Item的绑定
            relieveItemBind(){
                this.relieveItemBindDig = false;
                const params = [{
                    itemId: this.ready2relieveItem.itemId,
                    modelId:this.ready2relieveItem.modelId,
                    shopid:this.searchShopid,
                    token: "shopee-extension-erp",
                    userAccount:JSON.parse(localStorage.getItem("userInfo")).userId,
                    variationId: this.ready2relieveItem.variationId
                }]
                operation
                    .unbindModelAndItem(params)
                    .then(resp=>{
                        this.ready2relieveItem = {}
                        if (resp.code === 200){
                            alert(this.$t('other.a1644'))
                            this.accountMonitorItemList = [];
                            this.getAccountMonitorItemList()
                        }
                    })

            },
            /**
             * 切换店铺时候刷新数据
             */
            refreshData(){
                if (this.activeTab === 'first'){
                    this.getAccountItemsList()
                }
                if (this.activeTab === 'second'){
                    this.getAccountMonitorItemList()
                }
            },
            getMonitorPriceImg(){
                this.priceFlowDig = true;
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('priceFlow'));

                // 指定图表的配置项和数据
                let option = {
                    title: {
                        text: 'ECharts 入门示例'
                    },
                    tooltip: {},
                    legend: {
                        data:['销量']
                    },
                    xAxis: {
                        data: ["衬衫","羊毛衫","雪纺衫","裤子","高跟鞋","袜子"]
                    },
                    yAxis: {},
                    series: [{
                        name: '销量',
                        type: 'bar',
                        data: [5, 20, 36, 10, 10, 20]
                    }]
                };

                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
            },
            setUpdateMonitorRuleInfo(row){
                this.updateMonitorRuleDig = true;
                this.updateMonitorInfo = row;
                this.formatMonitorDate2display(row)
            },
            updateMonitorRule(){
                this.updateMonitorRuleDig = false;
                const params ={
                    bottomPrice:this.updateMonitorInfo.bottomPrice,
                    cutPrice:this.updateMonitorInfo.cutPrice,
                    cutType:parseInt(this.updateMonitorInfo.cutType),
                    itemId: this.updateMonitorInfo.itemId,
                    priceStrategyId: this.updateMonitorInfo.priceStrategyId,
                    shopid:this.searchShopid,
                    token:"shopee-extension-erp",
                    userAccount:JSON.parse(localStorage.getItem("userInfo")).userId,
                }
                operation
                .updateMonitorRule(params)
                .then(resp=>{
                    if (resp.code === 200){
                        alert(this.$t('other.a1645'))
                    }

                })
            },
            formatMonitorDate2display(row){
                this.displayMonitorDataInfo = [{
                    modelId: row.modelId,
                    modelImgUrl: row.modelImg,
                    lastPromotionPrice: row.lastPromotionPrice,
                    comment: row.comment
                }]
            }
        },
        watch: {
            addMonitorItem:function () {
                this.model2MonitorSelected = []
            },
        },
        computed:{
            accountMonitorItemCount(){
              return this.accountMonitorItemList.length
            },
            getCurrentPage(){
                let pageItem
                if (this.activeTab === 'first'){
                    pageItem =this.accountItemList
                    return pageItem
                }
                if (this.activeTab === 'second'){
                    pageItem = this.accountMonitorItemList
                }
                // let filterByStatus = pageItem.filter(element =>{
                //     if (this.searchStatus === "ALL"){
                //         return true
                //     }else{
                //         if (element.status === this.searchStatus){
                //             return true
                //         } else{
                //             return false
                //         }
                //     }
                //
                // })
                let currentPage = pageItem.slice(this.pageInfo.offset,this.pageInfo.offset+this.pageInfo.pageSize)
                // this.currentItemListLen = filterByStatus.length
                return currentPage
            }
        }
    };
</script>

<style scoped>
    .el-header {
        background-color: #f9fbff;
        color: #333;
        line-height: 60px;
    }

    .el-aside {
        color: #333;
    }

    /* #discountMain {
		flex: 1;
		margin: 60px 0 0 235px;
	} */

    #variation {
        float: none;
        flex: 1;
    }

    .Pager{
        position: fixed;
        bottom: 0;
        left: 235px;
        right: 0;
        height: 40px;
        line-height: 40px;
        background-color: #fff;
        text-align:right;
    }
</style>